import { Plus, Minus } from 'lucide-react'
import { Button } from './button'

interface QuantityControlProps {
  value: number
  onDecrement: () => void
  onIncrement: () => void
  decrementDisabled?: boolean
  incrementDisabled?: boolean
  size?: 'sm' | 'md'
  variant?: 'ghost' | 'outline'
  className?: string
}

export function QuantityControl({
  value,
  onDecrement,
  onIncrement,
  decrementDisabled = false,
  incrementDisabled = false,
  size = 'sm',
  variant = 'ghost',
  className = '',
}: QuantityControlProps) {
  const btnSize = size === 'sm' ? 'h-8 w-8' : 'h-10 w-10'
  const iconSize = size === 'sm' ? 'h-3.5 w-3.5' : 'h-4 w-4'
  const textClass = size === 'sm'
    ? 'min-w-[28px] text-sm text-center font-semibold tabular-nums'
    : 'text-xl font-bold w-12 text-center'

  return (
    <div className={`flex items-center ${variant === 'ghost' ? 'border border-border rounded-full' : 'gap-3'} ${className}`}>
      <Button
        variant={variant}
        size="icon"
        className={`${btnSize} rounded-full`}
        onClick={onDecrement}
        disabled={decrementDisabled}
        aria-label="Decrease quantity"
      >
        <Minus className={iconSize} />
      </Button>
      <span className={textClass} aria-live="polite" aria-label={`Quantity: ${value}`}>
        {value}
      </span>
      <Button
        variant={variant}
        size="icon"
        className={`${btnSize} rounded-full`}
        onClick={onIncrement}
        disabled={incrementDisabled}
        aria-label="Increase quantity"
      >
        <Plus className={iconSize} />
      </Button>
    </div>
  )
}
